import lang from '@/lang'
import { selectionSteps } from '@/redux/ducks/upgrade/wizard'
import type { StepType } from '../hooks/useUpgradeSteps'
import getVisibleStepIndex from './getVisibleStep'

/**
 * Title of the checkout page, e.g. "Schritt 2 – Add-ons ergänzen" - shown in the header on desktop
 * and above the stepper on mobile.
 */
const getCheckoutTitle = (activeStep: StepType | null, orderCompleted: boolean): string => {
  const texts = lang.upgrade.wizard
  if (orderCompleted) return texts.titles.success

  const stepTitle = selectionSteps.includes(activeStep) ? texts.titles.selection : texts.titles[activeStep]
  return texts.stepTitle(getVisibleStepIndex(activeStep) + 1, stepTitle)
}

export default getCheckoutTitle
